import { render, staticRenderFns } from "./multiInstance.vue?vue&type=template&id=122d5805"
import script from "./multiInstance.vue?vue&type=script&lang=js"
export * from "./multiInstance.vue?vue&type=script&lang=js"
import style0 from "./multiInstance.vue?vue&type=style&index=0&id=122d5805&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports